import { Globe, Check } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { LANGUAGES } from "@/lib/data";

export const LanguageSelector = ({ value, onChange, dark = false }) => {
  const current = LANGUAGES.find((l) => l.code === value) || LANGUAGES[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-selector-trigger"
          className={`flex items-center gap-2 rounded-full px-3.5 py-2 text-sm font-semibold transition-colors ${
            dark
              ? "bg-white/15 text-white hover:bg-white/25 backdrop-blur-md"
              : "bg-secondary text-secondary-foreground hover:bg-[#E0F2FE]"
          }`}
        >
          <Globe className="h-4 w-4" />
          <span className="hidden sm:inline">{current.native}</span>
          <span className="sm:hidden uppercase">{current.code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-80 overflow-y-auto no-scrollbar">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => onChange(l.code)}
            className="flex items-center justify-between gap-6 cursor-pointer"
          >
            <span>{l.native}</span>
            {l.code === value && <Check className="h-4 w-4 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
